import { HelperResult, Milestone } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetMilestoneProps {
  projectId: number;
  sectionId: number;
  milestoneId: number;
}

interface FindMilestonesProps {
  projectId: number;
  sectionId: number;
}

interface CreateMilestoneProps {
  title: string;
  content: string;
}

const {
  useGet: useProjectSectionMilestone,
  useFind: useProjectSectionMilestones,
  useCreate: useProjectSectionMilestonesCreation,
  useUpdate: useProjectSectionMilestonesUpdate,
  useDelete: useProjectSectionMilestonesDeletion,
} = getCRUDHooks({
  entityName: 'projectSectionMilestones',
  get: ({ projectId, sectionId, milestoneId }: GetMilestoneProps): HelperResult<Milestone> =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .sections.id(sectionId)
      .milestones.get(milestoneId),
  find: ({ projectId, sectionId }: FindMilestonesProps) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .sections.id(sectionId)
      .milestones.find(),
  create: (
    { title, content }: CreateMilestoneProps,
    { projectId, sectionId }: FindMilestonesProps
  ) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .sections.id(sectionId)
      .milestones.create({ title, content }),
  update: (values, { projectId, sectionId, milestoneId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .sections.id(sectionId)
      .milestones.partialUpdate(milestoneId, values),
  remove: ({ projectId, sectionId, milestoneId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .sections.id(sectionId)
      .milestones.delete(milestoneId),
});

export {
  useProjectSectionMilestone,
  useProjectSectionMilestones,
  useProjectSectionMilestonesCreation,
  useProjectSectionMilestonesUpdate,
  useProjectSectionMilestonesDeletion,
};
